import Navigator from './components/Navigation';
import { AboutList } from './components/AboutList';
import { Divider, Hidden } from '@mui/material';
import './style.css';
import './font.css';
import { Footer } from './components/Footer';
import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { Dispatch, SetStateAction, useState } from 'react';
import wavedivider from './image/wavedivider.webp'
import circle from './image/circle.webp';
import image1 from './image/@.webp';
import image2 from './image/*.webp';
import image3 from './image/shooting.webp';
import daangnCursor from './image/daangn.png';
import './animation.css';
import { Wavedivider } from './components/Wavedivider';
import LineByLineReveal from './components/LineByLineReveal';
import { useTranslation } from './hooks/useTranslation';
import { useLanguage } from './contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { BulletListItem } from './components/BulletListItem';
import { useMetaTags } from './utils/useMetaTags';
import waiting from './image/waiting.webp';

function About(props: {
  activeNav: number, 
  setActiveNav: Dispatch<SetStateAction<number>>,
}) {
    // 번역 기능 추가 (소개 섹션과 Experience 타이틀은 영어로 유지)
    const educationTitleTranslation = useTranslation('Education');
    const educationDescriptionTranslation = useTranslation('I studied Industrial Design at Seoul National University, focusing on user experience design and product design.');
    const activitiesTitleTranslation = useTranslation('Activities');
    const activitiesDescriptionTranslation = useTranslation('I have participated in various design projects and exhibitions, including international design exhibitions and UX research projects.');

    const { language } = useLanguage();
    const navigate = useNavigate();
    const [typingDone, setTypingDone] = useState(false);
    
    useMetaTags({
      title: 'Lynkim - Product Designer',
      description: "Product Designer Lynkim's Portfolio Site",
      image: '/ogimage.png',
    });

    return (
      <>
      <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav}/>
      <div style={{overflowX: "hidden", overflowY: "visible"}}>
        <div>
          <div className='aboutIntroSection fadeIn'
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  flexFlow: "column"

                  }}>
            <div className='aboutIntro'>
              {/* Product Designer <br/>  */}
              Lyn Kim</div>
            <img src={circle} className='circle'/>
            <div style={{ position: "absolute", top:"120px", margin : "48px"}}>
              <img src={image1} className='moveCircle1'/>
              <img src={image2} className='tilt' />
              <img src={image2} className='tilt' style={{ left: 580, top: 440 }} />
              <img src={image2} className='twinkle' style={{ left: -600, top: 320 }} />
              {/* <img src={image2} className='twinkle'/> */}
              <img src={image3} className='shooting'/>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <div className='aboutIntroDescription'>
                <LineByLineReveal
                  lines={language === 'ko' ? [
                    "세상의 온갖 재미를 많은 사람들과 함께 느끼며 살아가는 목표로 살고 있어요.",
                    "Product Designer로 일하고 있어요. 최근 금융업에서 새로운 도전을 시작했어요.",
                    "멘탈헬스케어, 커뮤니티, 커머스, 광고와 오프라인 주문/결제 도메인을 경험했고,전문가가 사용할 수 있는 툴 서비스를 디자인하는 것에 더 많은 관심을 갖고 있어요.",
                    "최근 당구와 탁구의 매력을 알게 되었고,펜싱과 피겨스케이팅을 좋아하지만 잠시 쉬어가고 있어요.",
                    
                    "다양한 엔터테인먼트에 관련된 것에서 기획하는 것을 좋아하고, 직접 보드게임을 만들고 있어요.",
                    "이제 막 피어난 새싹과 막바지에 화려하게 물든 단풍을 보는 것을 좋아해요.",
                    "지금은 이전의 모습에서 벗어나, 완전히 다른 새로운 삶을 살아가보려고 시도하고 있어요.",
                  ] : [
                    "My goal is to experience every kind of joy life has to offer, alongside as many people as possible.",
                    "I work as a Product Designer, and recently started a new chapter in the finance industry.",
                    "I've worked across mental healthcare, community, commerce, advertising, and offline ordering — and I'm increasingly drawn to designing tools built for experts.",
                    "I recently discovered the charm of billiards and table tennis,",
                    "and though I love fencing and figure skating, I'm taking a little break from both.",
                    "I enjoy planning things related to all kinds of entertainment, and I'm currently designing my own board game.",
                    "I love seeing the first sprouts of spring and the vivid glow of autumn leaves at their peak.",
                    "Right now, I'm trying to step away from who I used to be and build an entirely new life.",
                  ]}
                  delayBetween={350}
                  onComplete={() => setTypingDone(true)}
                />
              </div>
              <button
                onClick={() => navigate('/AboutPastRecords')}
                style={{
                  background: 'var(--color-bg-soft-warm)',
                  border: 'none',
                  borderRadius: '30px',
                  padding: '11px 16px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: '600',
                  color: 'var(--color-text-secondary)',
                  transition: 'background-color 0.2s ease, color 0.2s ease, opacity 0.8s ease',
                  alignSelf: 'center',
                  opacity: typingDone ? 1 : 0,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--color-text-primary)';
                  e.currentTarget.style.color = 'var(--color-bg-base)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--color-bg-soft-warm)';
                  e.currentTarget.style.color = 'var(--color-text-secondary)';
                }}
              >
                이전 기록
              </button>
              <img src={waiting} className="flow" style={{ alignSelf: 'center' }}/>
            </div>
          </div>
        </div>
        <Wavedivider/>
      
      <div className='aboutContents'>
        <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce={true} offset={10} style={{gap: "28px", flexDirection: "column", display: "flex"}}>
          <div className='aboutTitle'>Experience</div>
          <div className='aboutDescription'>
          {language === 'ko' ? (
                  <div>약 8년간 Product Designer로서, 사용자가 비즈니스가 설계한 가치에 쉽게 도달할 수 있도록 디자인의 원칙정의, 구조설계, UI 디자인을 하며, 전문성을 갖춰왔습니다. 또한 Product Manager와 스타트업의 Founder로서 역할을 수행하여, 제품에 대한 오너십을 갖고 전략을 수립하여 비즈니스를 책임지고 성장시켰습니다. 
                  제품의 전체 생애주기(Product Lifecycle)를 책임지고 관리하며, 비즈니스 레벨에서 신규고객 발굴부터 사용자의 가장 가까운 시선에서 UX의 완성도를 함께 책임집니다.</div>
                ) : (
                  <div>A Product Designer and former Founder with 8 years of expertise in building scalable design systems and intuitive user structures. I possess a unique blend of design craft and business acumen, having led product strategies that directly contribute to bottom-line growth. I am committed to overseeing the entire product lifecycle, ensuring that business value is translated into user-centric design with the highest level of polish.</div>
                )}
          </div>
        </AnimationOnScroll>
          
          <div>
            {/* 당근 로컬비즈니스 QR */}
            <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce={true} offset={10}>
            <Divider className = 'divider1'/>
              <AboutList 
                companyTitle = {<a target='_blank' href='https://business.daangn.com/qr-order' style={{cursor: `url(${daangnCursor}), auto`}}>Karrot(당근)<br/>QR-Order, Local business</a>}
                experience = {language === 'ko' ? (
                  <>
                    <BulletListItem><b>시장 분석 기반의 MVP 개발</b>: 종합적인 시장 및 경쟁사 분석을 통해 제품의 핵심 스펙을 정의하고, 최소 기능 제품(MVP)을 개발하여, 1개월 만에 서비스를 출시했습니다.</BulletListItem>
                    <BulletListItem><b>제품 전략 수립 및 분기별 로드맵 실행</b>: QR오더 서비스의 시장 경쟁구조를 분석하고 제품 전략과 로드맵을 수립했으며, 분기별 목표(OKR)와 핵심 결과 지표(Key Results)를 정의하여 비즈니스 성장을 견인했습니다.</BulletListItem>
                    <BulletListItem><b>팀내 협업 및 프로젝트 관리</b>: 프로젝트의 우선순위를 조정하고 팀의 리소스를 관리하여, 임팩트가 큰 주요 기능들을 차질 없이 배포하여, 출시 4개월 만에 거래액 3억원 등 빠른 성장을 만들었습니다. </BulletListItem>
                    <BulletListItem><b>외부 파트너십 협업 체계 구축</b>: 외부 협력사와의 원활한 협업을 위한 프레임워크를 수립하여, 양사 간의 커뮤니케이션 효율성과 운영 효율성을 극대화했습니다.</BulletListItem>
                    <BulletListItem><b>End-to-End UX/UI 설계</b>: 초기 런칭을 위해 고도화된 유저 플로우(User Flow)와 직관적인 인터페이스를 중심으로 제품의 전체 디자인 구조를 설계하여, 사용자 만족도 높은 UX의 제품을 선보였습니다.</BulletListItem>
                  </>
                ) : (
                  <>
                    <BulletListItem><b>Spearheaded MVP Development & Rapid Launch</b>: Defined core product specifications through comprehensive market and competitor analysis; successfully launched the MVP within just one month of development.</BulletListItem>
                    <BulletListItem><b>Strategic Roadmap & OKR Management</b>: Analyzed market competitive structures to establish long-term product strategies and quarterly roadmaps; drove business growth by defining and achieving high-impact OKRs and Key Results.</BulletListItem>
                    <BulletListItem><b>Project Management & Growth Acceleration</b>: Optimized team resources and prioritized feature backlogs, leading to the seamless delivery of critical updates and achieving KRW 300M in transaction volume within 4 months of launch.</BulletListItem>
                    <BulletListItem><b>External Partnership Framework</b>: Established a robust collaboration framework with external vendors, maximizing operational efficiency and streamlining cross-functional communication between organizations.</BulletListItem>
                    <BulletListItem><b>End-to-End UX/UI Architecture</b>: Designed the entire product interface and sophisticated user flows from scratch, delivering a high-satisfaction user experience through an intuitive and polished UI.</BulletListItem>
                  </>
                )}
                perieod ={<div style={{display: 'flex', flexDirection:'row', textAlign:'right', right:'0'}}>
                  2025.06. - 2026.04.
                    {/* <div style={{textAlign:'right'}} className='textGradient'> &nbsp;Present</div> */}
                  </div>}
                location='Product Manager & Product Designer'
              />
              <Divider className = 'divider1'/>
            </AnimationOnScroll>
            
            {/* 당근 광고상품팀 */}
            <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce={true} offset={10}>
              <AboutList 
                companyTitle = {<a target='_blank' href='https://business.daangn.com/'>Karrot(당근)<br/>Ad Products, Ads</a>}
                experience = {language === 'ko' ? (
                  <>
                    <BulletListItem><b>신규 광고 지면 발굴 및 광고 상품 개발</b>: 높은 클릭률(CTR) 확보가 가능한 신규 지면을 발굴하였고, 동영상 광고 등 새로운 형태의 광고 상품을 기획 및 디자인하여 새로운 광고를 상품화하였습니다.</BulletListItem>
                    <BulletListItem><b>광고 UX/UI 개선 실험 주도를 통한 광고 매출 상승</b>: 광고 CTR 향상을 목표로 가설 수립, A/B 테스트 진행, 결과 분석을 통한 UI 개선 실험을 설계하였으며, 검증된 요소를 실제 서비스에 적용하여, 지속적으로 CTR 향상을 통한 광고 매출을 높였습니다.</BulletListItem>
                    <BulletListItem><b>광고 상품 UX 최적화</b>: 광고주에게는 높은 효율을, 사용자에게는 거부감 없는 경험을 제공하기 위해 광고 상품 전반의 UX 구조를 설계하고 고도화했습니다. </BulletListItem>
                    <BulletListItem><b>광고 플랫폼 인프라 설계 및 고도화</b>: 신규 카탈로그 광고 상품 운영을 위한 플랫폼 시스템을 설계하고, 고도화되는 검색 광고 상품에 최적화되도록, 광고 관리 플랫폼 UX를 고도화했습니다.</BulletListItem>
                     </>
                ) : (
                  <>
                    <BulletListItem><b>Ad Inventory Expansion & New Product Development</b>: Identified high-potential ad placements to secure elevated CTRs and spearheaded the end-to-end design and commercialization of new formats, including video-based ad products.</BulletListItem>
                    <BulletListItem><b>Revenue Growth through Systematic UX/UI Experimentation</b>: Drove continuous ad revenue growth by leading the full experimentation cycle—from hypothesis formulation and A/B testing to data analysis—resulting in significant and sustainable CTR improvements.</BulletListItem>
                    <BulletListItem><b>Optimization of Ad Experience (UX)</b>: Architected a balanced UX framework that maximizes conversion efficiency for advertisers while ensuring a seamless, non-intrusive experience for general users.</BulletListItem>
                    <BulletListItem><b>Ad Platform Infrastructure & Optimization</b>: Established the foundational UX infrastructure for a new Catalog Ad platform and advanced the Ad Management System to optimize the operational flow for sophisticated search-based ad products.</BulletListItem>
                    </>
                )}
                perieod ='2024.01. - 2025.06.'
                location='Product Designer'
              />
              <Divider className = 'divider1'/>
            </AnimationOnScroll>

            {/* 당근 광고 플랫폼팀*/}  
            <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce={true} offset={10}>
              <AboutList 
                companyTitle = {<a target='_blank' href='https://business.daangn.com/'>Karrot(당근)<br/>Ads platform, Ads</a>}
                experience = {language === 'ko' ? (
                  <>
                    <BulletListItem><b>광고관리 플랫폼 초기 제품 설계</b>: 당근 광고 플랫폼 및 상품을 위한 1인 디자이너로, 당근 광고 관리 플랫폼의 초기 제품 설계와 운영 환경 구축을 진행했습니다.</BulletListItem>
                    <BulletListItem><b>광고주 맞춤형 플랫폼 확장</b>: 지역 소상공인(SMB) 대상 광고 플랫폼을 시작으로, 중대형 브랜드 광고주를 위한 전문 비즈니스 플랫폼까지 제품 범위를 확장 및 디자인했습니다.</BulletListItem>
                    <BulletListItem><b>매체별 최적화된 광고 플랫폼 설계</b>: 피드형 및 검색형 광고 소재에 특화된 UX/UI를 설계하여 광고 운영 효율성을 높였습니다.</BulletListItem>
                    <BulletListItem><b>사용자 리서치 기반의 지속적 고도화</b>: 정기적인 고객 리서치를 통해 파악된 인사이트를 바탕으로 플랫폼의 UX를 지속적으로 개선하고 제품 완성도를 높였습니다.</BulletListItem>
                     </>
                ) : (
                  <>
                    <BulletListItem><b>Founding Product Designer for Ad Platform</b>: Served as the sole designer responsible for architecting the initial infrastructure and operational environment of the "Karrot Ads" management platform from the ground up.</BulletListItem>
                    <BulletListItem><b>Scalable Platform Expansion for Diverse Advertisers</b>: Successfully scaled the product ecosystem by designing tailored solutions ranging from SMB-focused interfaces to professional, enterprise-level platforms for major brand advertisers.</BulletListItem>
                    <BulletListItem><b>Specialized UX/UI for Diverse Ad Formats</b>: Enhanced operational efficiency by designing optimized management interfaces for specialized ad creatives, including In-feed and Search ad formats.</BulletListItem>
                    <BulletListItem><b>Evidence-Based Product Iteration</b>: Elevated product fidelity and UX quality by conducting regular user research and translating qualitative customer insights into actionable design enhancements.</BulletListItem>
                    </>
                )}
                perieod ='2021.10. - 2023.12.'
                location='Product Designer'
              />
              <Divider className = 'divider1'/>
            </AnimationOnScroll>


            <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce={true} offset={10}>
              <AboutList 
                companyTitle = {<a target='_blank' href='https://bookcovery.com'>Bookcovery</a>}
                experience = {language === 'ko' ? (
                  <>
                    <BulletListItem><b>서비스 비전 및 비즈니스 전략 수립</b>: 서비스의 핵심 가치와 방향성을 정의하고, 수익 구조 설계 및 제품 로드맵의 우선순위를 결정하여 사업 전반을 리딩했습니다.</BulletListItem>
                    <BulletListItem><b>초기 제품(MVP) UX 설계 및 구축</b>: 서비스 런칭을 위한 전체 사용자 경험(UX)을 설계하고 초기 제품을 구축하여 시장에 출시했습니다.</BulletListItem>
                    <BulletListItem><b>그로스 마케팅을 통한 사용자 확보</b>: 데이터 기반의 마케팅 및 그로스 전략을 실행하여 약 2만 명 이상의 활성 사용자(Active Users)를 확보하는 성과를 만들었습니다.</BulletListItem>
                    <BulletListItem><b>수익 모델 다각화 및 제휴 체결</b>: 국내 최대 규모인 교보문고와의 전략적 제휴를 성공적으로 이끌어내어 서비스의 지속 가능한 수익 구조를 마련했습니다.</BulletListItem>
                     </>
                ) : (
                  <>
                    <BulletListItem><b>Strategic Vision & Business Development</b>: Defined core product values and long-term strategic direction; led overall business operations by designing revenue models and prioritizing the product roadmap.</BulletListItem>
                    <BulletListItem><b>MVP Architecture & Market Launch</b>: Designed the entire user experience (UX) and built the Minimum Viable Product (MVP) from scratch, successfully leading the service through its initial market launch.</BulletListItem>
                    <BulletListItem><b>User Acquisition via Growth Hacking</b>: Executed data-driven marketing and growth strategies, resulting in the acquisition of over 20,000+ Active Users and establishing strong market traction.</BulletListItem>
                    <BulletListItem><b>Strategic Partnership & Monetization</b>: Secured a strategic partnership with Kyobo Book Centre, South Korea's largest bookstore chain, to establish a sustainable revenue stream and diversify the service's business model.</BulletListItem>
                    </>
                )}
                perieod ='2020.12 - 2021.08'
                location='Founder & Product Owner & Designer'
              />
              <Divider className = 'divider1'/>
            </AnimationOnScroll>

            <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce={true} offset={10}>
              <AboutList 
                companyTitle = 'Styleshare Growth Team'
                experience = {language === 'ko' ? (
                  <>
                    <BulletListItem><b>데이터 기반의 그로스 사이클 실행</b>: 1020 세대 타겟의 패션 커머스 환경에서 리텐션(Retention) 및 쇼핑 퍼널 전환율 향상을 목표로 가설 수립, A/B 테스트, 결과 분석 및 UX/UI 개선으로 이어지는 전체 그로스 프로세스를 수행했습니다.</BulletListItem>
                    <BulletListItem><b>Resurrection 프로젝트 주도</b>: 비활성 및 이탈 사용자를 대상으로 한 re-engagement 프로젝트를 주도하여, 마케팅 수신동의율을 기존 대비 2배 이상 증가시키는 정량적 성과를 달성했습니다.</BulletListItem>
                    <BulletListItem><b>쇼핑 퍼널 최적화</b>: 사용자 행동 데이터를 분석해 쇼핑 여정 내 이탈 지점을 발굴하고, 반복적인 디자인 개선 실험을 통해 장기적인 사용자 인게이지먼트를 강화했습니다.</BulletListItem>
                     </>
                ) : (
                  <>
                    <BulletListItem><b>Executed End-to-End Growth Cycles</b>: Driven by the goal of enhancing retention and shopping funnel conversion rates for Gen Z & Alpha audiences; led the entire process from hypothesis formulation and A/B testing to data-driven UX/UI optimization.</BulletListItem>
                    <BulletListItem><b>Led User Resurrection Project</b>: Spearheaded a strategic project targeting deactivated and churned users, achieving a 2x increase in marketing opt-in rates through optimized re-engagement funnels.</BulletListItem>
                    <BulletListItem><b>Data-Driven Decision Making</b>: Analyzed user behavioral data to identify drop-off points within the shopping journey, implementing iterative design solutions that boosted long-term user engagement.</BulletListItem>
                    </>
                )}
                perieod ='2020.06 - 2020.12'
                location='Growth Product Manager'
              />
              <Divider className = 'divider1'/>
            </AnimationOnScroll>
            <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce={true} offset={10}>
              <AboutList 
                companyTitle = 'Minding (Content-based Mental Healthcare Service)'
                experience = {language === 'ko' ? (
                  <>
                    <BulletListItem><b>제품 브랜딩 및 End-to-end 디자인</b>: 초기 브랜드 아이덴티티 수립부터 모바일 기반 마인드 헬스케어 서비스의 전체 UX/UI 디자인을 총괄했습니다.</BulletListItem>
                    <BulletListItem><b>일관성 있는 브랜드 디자인 시스템 구축</b>: 정서적 안정과 웰니스라는 서비스의 핵심 가치를 시각적으로 전달하기 위해 일관된 브랜드 보이스와 디자인 시스템을 수립했습니다.</BulletListItem>
                    <BulletListItem><b>콘텐츠 중심의 직관적 UX 설계</b>: 사용자의 심리적 안정과 쉬운 접근성을 고려하여 콘텐츠 소비에 최적화된 사용자 여정(User Journey)을 설계했습니다.</BulletListItem>
                    <BulletListItem><b>비주얼 원칙 및 UI 컴포넌트 정의</b>: 확장성을 고려한 디자인 원칙과 컴포넌트를 정의하여, 향후 서비스 업데이트와 기능 확장에 대응할 수 있는 기반을 마련했습니다.</BulletListItem>
                     </>
                ) : (
                  <>
                    <BulletListItem><b>Led end-to-end product design</b>, from initial brand identity development to the execution of high-fidelity UX/UI for a mobile mental healthcare platform.</BulletListItem>
                    <BulletListItem><b>Established a cohesive brand design system</b>, ensuring that visual elements align with the service's core values of mental wellness and emotional stability.</BulletListItem>
                    <BulletListItem><b>Architected intuitive user journeys for content-driven mental health features</b>, focusing on accessibility and calming user experiences.</BulletListItem>
                    <BulletListItem><b>Defined visual design principles and UI components</b>, creating a scalable framework to support continuous product updates and feature expansions.</BulletListItem>
                    </>
                )}
                perieod ='2018.07 - 2020.01'
                location='UX/UI Designer'
              />
              <Divider className = 'divider1'/>
            </AnimationOnScroll>
            <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce={true} offset={10}>
              <AboutList 
                companyTitle = "Seoul Nat'l Univ. & Samsung AI-UX Study Project"
                experience = {language === 'ko' ? (
                  <div>삼성과 협업하여 IoT를 활용한 Delight Shop UX 개선 프로젝트에 참여했습니다. 사용자 여정 분석과 인터뷰를 기반으로 매장 경험을 돕는 AI 안내 시스템을 설계했습니다.</div>
                ) : (
                  <div>In cooperation with Samsung, we conducted a UX improvement project for Delight Shop using IoT. Based on user journey analysis and user interviews, we have developed an artificial intelligence guide system that allows to enjoy the store experience.</div>
                )}
                perieod ='2018.04 - 2018.06'
                location='Intern · Human-Centered Interaction Design (HCID) Lab, Graduate School of Design, Seoul National University'
              />
              <Divider className = 'divider1'/>
            </AnimationOnScroll>
            <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce={true} offset={10}>
            <AboutList 
              companyTitle = 'Salone del Mobile Milano Exhibition'
              experience = {language === 'ko' ? (
                <div>“Seoul”을 주제로 한 전시를 진행했습니다. 서울의 빛을 표현한 조명은 레진과 한국 전통직물인 가재천으로 제작했습니다.</div>
              ) : (
                <div>The exhibition was held under the theme of “Seoul”. The lighting that expresses the light of Seoul is made of resin and the traditional Korean cloth, kagi cloth.</div>
              )}
              perieod ='2018.04'
              location='Student · Seoul National University'
            />
            </AnimationOnScroll>
          </div>
        </div>
        <Footer/>
        </div>
      </>
    )
}

export default About;